import { formatInTimeZone } from 'date-fns-tz'

// Período do Financeiro: a mesma conta do backend (financeiros.services.ts)
const DEFAULT_TIMEZONE = 'America/Sao_Paulo'
const MAX_RETROACTIVE_DAYS = 365

// null = sem restrição · 0 = somente hoje · N = hoje e os N dias anteriores
// Nunca testar com "if (days)": 0 é uma restrição válida.
export function getRetroactiveDays(user) {
  const days = user?.parameters?.financial_retroactive_days
  if ((days === null) || (days === undefined)) return null

  // Mesma normalização do backend (0 a 365)
  return Number.isFinite(days) ? Math.min(MAX_RETROACTIVE_DAYS, Math.max(0, Math.trunc(days))) : 0
}

// Mesmo fuso do backend: o do usuário, com São Paulo se vier vazio ou inválido (ex.: 'Brasilia')
function getUserTimeZone(user) {
  const timeZone = user?.timezone_name
  if (!timeZone) return DEFAULT_TIMEZONE

  try {
    new Intl.DateTimeFormat('pt-BR', { timeZone })
    return timeZone
  } catch (error) {
    return DEFAULT_TIMEZONE
  }
}

// Janela do usuário em 'yyyy-MM-dd': relógio do navegador, data no fuso do usuário. null = sem restrição.
// Chamar a cada busca, sem guardar: uma aba aberta desde ontem passa a usar o dia novo.
export function getUserPeriod(user, now = new Date()) {
  const days = getRetroactiveDays(user)
  if (days === null) return null

  const today = formatInTimeZone(now, getUserTimeZone(user), 'yyyy-MM-dd')

  // Subtração em UTC sobre a data pura: não depende do fuso do Windows
  const start = new Date(`${today}T00:00:00.000Z`)
  start.setUTCDate(start.getUTCDate() - days)

  return { data_inicial: start.toISOString().split('T')[0], data_final: today }
}

// Valor total do Financeiro: só false oculta. Ausente (usuário sem parâmetros) = vê, como o padrão do backend
export function canSeeFinancialTotal(user) {
  return user?.parameters?.financial_show_total !== false
}
